require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/index.js
// module id = 371
// module chunks = 168707334958949